import { render, staticRenderFns } from "./DrawerPs.vue?vue&type=template&id=4b602492&scoped=true&"
import script from "./DrawerPs.vue?vue&type=script&lang=js&"
export * from "./DrawerPs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b602492",
  null
  
)

export default component.exports